import React from 'react';
const bonuses = [{
  num: '01',
  emoji: '📋',
  title: 'Primera Entrevista y Anamnesis',
  desc: 'Evaluaciones iniciales profesionales y detección de señales de alerta desde la primera consulta.',
  price: '$12.000'
}, {
  num: '02',
  emoji: '📝',
  title: 'Redacción de Informes Profesionales',
  desc: 'Informes claros y objetivos para familias y equipos interdisciplinarios.',
  price: '$9.000'
}, {
  num: '03',
  emoji: '🧩',
  title: 'Abordaje de Desregulación en Sesión',
  desc: 'Estrategias para manejar crisis y desregulación emocional durante las intervenciones.',
  price: '$10.000'
}, {
  num: '04',
  emoji: '🚨',
  title: 'Radar de Alertas y Criterios de Derivación',
  desc: 'Detectá señales de riesgo y tomá decisiones clínicas fundamentadas.',
  price: '$9.000'
}, {
  num: '05',
  emoji: '🧸',
  title: 'Diccionario de Juguetes con Sentido',
  desc: '+40 páginas para usar materiales terapéuticos con objetivos clínicos concretos.',
  price: '$8.000'
}, {
  num: '06',
  emoji: '👨‍👩‍👧',
  title: 'Encuadre y Comunicación con Familias',
  desc: 'Ordená el vínculo con las familias y sostené el proceso clínico desde el consultorio.',
  price: '$10.000'
}];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(240,249,255) 0%, rgb(240,249,255) 50%, #ffffff 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-353">
      <div className="mx-auto max-w-4xl" data-id="element-354">

        {/* Heading */}
        <h2 className="text-2xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-355">
          Más los{' '}
          <span className="text-cyan-brand" data-id="element-356">6 Bonos de Autoridad Profesional</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-357">
          Resuelven los problemas de gestión que ningún tomo clínico cubre — incluidos en todas las ofertas
        </p>

        {/* Bonus list */}
        <div className="bg-white border border-cyan-brand/20 rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-358">
          <div className="bg-cyan-brand px-5 py-3" data-id="element-359">
            <h3 className="text-sm font-black text-white m-0" data-id="element-360">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-361">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-3" data-id="element-362">
                <span className="shrink-0 text-xl w-8 text-center" data-id="element-363">
                  {bonus.emoji}
                </span>
                <div className="flex-1 min-w-0" data-id="element-364">
                  <span className="block text-sm font-black text-gray-900" data-id="element-365">
                    {bonus.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-366">
                    {bonus.desc}
                  </span>
                </div>
                <div className="shrink-0 flex flex-col items-center gap-1 min-w-[64px]" data-id="element-367">
                  <span className="text-xs font-bold text-gray-400 line-through" data-id="element-368">
                    {bonus.price}
                  </span>
                  <span className="text-[11px] font-black text-white rounded-full px-3 py-1 text-center" style={{
                backgroundColor: 'rgb(0,180,216)'
              }} data-id="element-369">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Total value */}
        <div className="text-center rounded-xl px-5 py-4" style={{
        backgroundColor: 'rgb(240,249,255)',
        border: '1px solid rgba(0,180,216,0.3)'
      }} data-id="element-370">
          <p className="text-xs font-bold uppercase tracking-widest text-cyan-brand m-0 mb-1" data-id="element-371">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-372">
            <span className="text-base text-gray-400 line-through" data-id="element-373">$58.000</span>
            <span className="text-lg font-black text-cyan-brand" data-id="element-374">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>

      </div>
    </section>;
}